import { AnyAction } from 'redux';
import { FetchLatestVersionRoutine } from '../redux-routines';

export interface ILatestVersionState {
  isFetching: boolean;
  version: string | null;
  available: boolean;
  existing_release_id: string | null;
  error: any;
}

const initialState: ILatestVersionState = {
  isFetching: false,
  version: null,
  available: false,
  existing_release_id: null,
  error: null
};

export const latestVersionReducer = (
  state: ILatestVersionState = initialState,
  action: AnyAction
): ILatestVersionState => {
  switch (action.type) {
    case FetchLatestVersionRoutine.REQUEST:
      return {
        ...state,
        isFetching: true,
        error: null
      };

    case FetchLatestVersionRoutine.SUCCESS:
      return {
        ...state,
        isFetching: false,
        version: action.payload.version,
        available: action.payload.available,
        existing_release_id: action.payload.existing_release_id,
        error: null
      };

    case FetchLatestVersionRoutine.FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.payload
      };

    default:
      return state;
  }
};